import src from "IMAGE";
export default { src, width: 363, height: 197, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAOElEQVR42nXJ0QoAEQAF0butbZUQiv//U6MoKVPnaSSpoSIj4IfBo1lBQoTFu8+Rh8N3jpW5jVEHSA4AvLseUq8AAAAASUVORK5CYII="};
